// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__V_5E2","rootCenter":"LoadMoreObserver_rootCenter__2dW1j","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__gSYXl"};